import { AppExtensionService } from '@alfresco/aca-shared';
import {
  ContentActionRef,
  ExtensionConfig,
  ExtensionService,
  NavBarGroupRef,
  RuleEvaluator,
} from '@alfresco/adf-extensions';
import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WkCoreExtensionService {
  config: ExtensionConfig = null;
  protected onSetup$ = new BehaviorSubject<ExtensionConfig>(this.config);
  setup$ = this.onSetup$.asObservable();

  get documentListPresets() {
    return this.appExtensionService.filesDocumentListPreset$;
  }
  get navbar(): NavBarGroupRef[] {
    return this.appExtensionService.navbar;
  }
  constructor(
    private readonly appExtensionService: AppExtensionService,
    private readonly extensionService: ExtensionService
  ) {}

  async load() {
    await this.appExtensionService.load();
    this.config = this.appExtensionService.config;
    this.onSetup$.next(this.config);
  }

  public setComponents(value: { [key: string]: Type<{}> }): void {
    this.extensionService.setComponents(value);
  }

  public setAuthGuards(value: Record<string, unknown>): void {
    this.extensionService.setAuthGuards(value);
  }

  public setEvaluators(value: { [key: string]: RuleEvaluator }): void {
    this.extensionService.setEvaluators(value);
  }

  public getAllowedToolbarActions(): Observable<ContentActionRef[]> {
    return this.appExtensionService.getAllowedToolbarActions();
  }

  public getViewerToolbarActions(): Observable<ContentActionRef[]> {
    return this.appExtensionService.getViewerToolbarActions();
  }

  public getApplicationNavigation(elements: any): NavBarGroupRef[] {
    return this.appExtensionService.getApplicationNavigation(elements);
  }
}
